module.exports = __webpack_public_path__ + "img/image-001.08376254.png";